/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchUsers = /* GraphQL */ `
  query SearchUsers($query: String!) {
    searchUsers(query: $query) {
      username
      __typename
    }
  }
`;
export const getLeaderboard = /* GraphQL */ `
  query GetLeaderboard {
    getLeaderboard {
      username
      postCount
      avgOverall
      minOverall
      maxOverall
      favoriteLocation
      favoriteLocationCount
      __typename
    }
  }
`;
export const getBreakdownRating = /* GraphQL */ `
  query GetBreakdownRating($id: ID!) {
    getBreakdownRating(id: $id) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      name
      value
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listBreakdownRatings = /* GraphQL */ `
  query ListBreakdownRatings(
    $filter: ModelBreakdownRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBreakdownRatings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ratingID
        rating {
          id
          type
          title
          owner
          yelpBusinessId
          yelpBusinessName
          restaurantName
          imgKeys
          description
          overall
          is_pini_adjacent
          breakdownRatings {
            nextToken
            __typename
          }
          createdAt
          likes {
            nextToken
            __typename
          }
          comments {
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        name
        value
        notes
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRating = /* GraphQL */ `
  query GetRating($id: ID!) {
    getRating(id: $id) {
      id
      type
      title
      owner
      yelpBusinessId
      yelpBusinessName
      restaurantName
      imgKeys
      description
      overall
      is_pini_adjacent
      breakdownRatings {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          name
          value
          notes
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      likes {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          content
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listRatings = /* GraphQL */ `
  query ListRatings(
    $filter: ModelRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLike = /* GraphQL */ `
  query GetLike($id: ID!) {
    getLike(id: $id) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listLikes = /* GraphQL */ `
  query ListLikes(
    $filter: ModelLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ratingID
        rating {
          id
          type
          title
          owner
          yelpBusinessId
          yelpBusinessName
          restaurantName
          imgKeys
          description
          overall
          is_pini_adjacent
          breakdownRatings {
            nextToken
            __typename
          }
          createdAt
          likes {
            nextToken
            __typename
          }
          comments {
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ratingID
        rating {
          id
          type
          title
          owner
          yelpBusinessId
          yelpBusinessName
          restaurantName
          imgKeys
          description
          overall
          is_pini_adjacent
          breakdownRatings {
            nextToken
            __typename
          }
          createdAt
          likes {
            nextToken
            __typename
          }
          comments {
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        content
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const yelpBusinessSearch = /* GraphQL */ `
  query YelpBusinessSearch($query: QueryYelpBusinessSearchQueryInput!) {
    yelpBusinessSearch(query: $query) {
      businesses {
        id
        name
        alias
        url
        price
        distance
        coordinates
        review_count
        rating
        transactions
        image_url
        categories
        display_phone
        phone
        location {
          address1
          address2
          address3
          city
          zip_code
          country
          state
          display_address
          __typename
        }
        is_closed
        __typename
      }
      region
      total
      __typename
    }
  }
`;
export const getRatingsByDate = /* GraphQL */ `
  query GetRatingsByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getRatingsByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRatingsByOverall = /* GraphQL */ `
  query GetRatingsByOverall(
    $type: String
    $overall: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getRatingsByOverall(
      type: $type
      overall: $overall
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRatingsByOwner = /* GraphQL */ `
  query GetRatingsByOwner(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getRatingsByOwner(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
